import { EditorialMessageContent } from "./EditorialMessageContent";
import { DataRelatedBuilder } from "./DataRelatedBuilder";
import { truncateSummary } from "../services/summary.service";
import { CalendarEventDate } from "../../shared/models/calendarEventDate";
import { MessageContent } from "./MessageContent";

export class CalendarDataRelatedBuilder implements DataRelatedBuilder <CalendarEventDate> {
  build(eventDate: CalendarEventDate, content: EditorialMessageContent): MessageContent {
    content.relatedCalendarEventContent = {
      Id: eventDate.id,
      EventId: eventDate.eventId,
      Name: eventDate.name,
      Description: truncateSummary(eventDate.description),
      Actual: eventDate.actual,
      Consensus: eventDate.consensus,
      Previous: eventDate.previous,
      DateUtc: eventDate.dateUtc,
      UrlSource: eventDate.urlSource,
      Source: eventDate.source,
      CountryCode: eventDate.countryCode,
      IsSpeech: eventDate.isSpeech,
      IsReport: eventDate.isReport,
      IsAllDay: eventDate.isAllDay,
      Volatility: eventDate.volatility,
      Unit: eventDate.unit,
      Potency: eventDate.potency
    }
    content.relatedRecordingContent = null;
    content.relatedWebinarContent = null;
    content.relatedPostContent = null;
    return content;
  }
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/models/CalendarDataRelatedBuilder.ts